import React, { createContext, useContext, useState } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [toggleSidebar, setToggleSidebar] = useState(false);


  return (
    <GlobalContext.Provider value={{ 
        toggleSidebar,
        setToggleSidebar
        }}>
      {children}
    </GlobalContext.Provider>
  );
};


export const useGlobalContext = () => useContext(GlobalContext);